"use client";

import { c as _c } from "react/compiler-runtime";
import { IconBellOutline18 } from "nucleo-ui-outline-18";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useNotifications } from "@/hooks/useNotifications";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { NotificationPanel } from "./NotificationPanel";
export function NotificationBell(t0) {
  const $ = _c(21);
  const {
    className
  } = t0;
  const [open, setOpen] = useState(false);
  const {
    unreadCount,
    fetchNotifications,
    markNotificationRead,
    markAllNotificationsRead
  } = useNotifications();
  let t1;
  if ($[0] !== fetchNotifications) {
    t1 = isOpen => {
      setOpen(isOpen);
      if (isOpen) {
        fetchNotifications();
      }
    };
    $[0] = fetchNotifications;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = unreadCount > 0 ? `Notifications (${unreadCount} unread)` : "Notifications";
  let t3;
  if ($[2] !== className) {
    t3 = cn("text-ds-text-muted hover:bg-ds-surface-hover hover:text-ds-text-primary dark:hover:bg-ds-neutral-800 relative inline-flex size-8 items-center justify-center rounded-lg transition-colors dark:hover:text-white", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconBellOutline18 className="size-4" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== unreadCount) {
    t5 = unreadCount > 0 && <span className="bg-ds-brand-500 ring-ds-surface-secondary text-3xs absolute right-1 top-1 flex h-4 min-w-4 -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full px-1 font-semibold leading-none text-white ring-2 dark:ring-zinc-950">{unreadCount > 99 ? "99+" : unreadCount}</span>;
    $[5] = unreadCount;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t5) {
    t6 = <PopoverTrigger asChild={true}><button type="button" aria-label={t2} className={t3}>{t4}{t5}</button></PopoverTrigger>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      left: 12,
      right: 16,
      top: 16,
      bottom: 16
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpen(false);
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== markAllNotificationsRead || $[14] !== markNotificationRead) {
    t9 = <PopoverContent align="end" side="bottom" sideOffset={8} alignOffset={16} collisionPadding={t7} className="border-ds-border-default bg-ds-surface-card w-80 p-0"><div className="flex h-[calc(100dvh-136px)] flex-col p-2"><NotificationPanel onMarkRead={markNotificationRead} onMarkAllRead={markAllNotificationsRead} onNavigate={t8} /></div></PopoverContent>;
    $[13] = markAllNotificationsRead;
    $[14] = markNotificationRead;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== open || $[17] !== t1 || $[18] !== t6 || $[19] !== t9) {
    t10 = <Popover open={open} onOpenChange={t1}>{t6}{t9}</Popover>;
    $[16] = open;
    $[17] = t1;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}